import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  a,
  BoxC,
  GridC,
  HtyC,
  IptC,
  LblC,
  SrlC,
  TextC,
  _cv_41___Ci,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as HtyC from "./_ccmHtyC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as _cv_41___Ci from "./_cv_41___Ci";
import * as ht from './_ht';
import * as hf from './_hf';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                ]
              },
              {
                oClds: [
/*
                  cr.c(LblC.N, {
                    key: -10,
                    abtType: 'ftnCmnz',
                    boxStlz: a('dw/23'),
                    lblCz: {
                      boxStlz: a('dw/8'),
                      textz: {
                        pfx: '変更履歴',
                      }
                    },
                    cttCz: {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          abtType: 'ftnCmnz',
                          cz: {
                            bEdit: true,
                            iptType: 'pcr',
                            ls: [],
                          },
                        })
                      ]
                    },
                  })
*/
                  cr.c(HtyC.N, {
                    key: -10,
                    sPz: pz.sPz,
                    cz: {
                      elm: '_41r',
//                      cdn: `_icn = '${pz.sPz.crt._50r_icn}'`
//                        _fst: pz.sPz.crt.i15r_fst,
                    }
                  })

                ]
              }
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

/*
            cr.c(MsgC.N, {
              key: -10,
              abtType: 'cttCmnz',
              boxStlz: a('mb/2'),
              cz: {
                ls: [
                  {
                    mkrCz: {
                      textz: {
                        pfx: _lblz.msgz.cttz.mkr
                      }
                    },
                    msgCz: {
                      textz: {
                        pfx: _lblz.msgz.cttz.msg
                      }
                    }
                  },
                ]
              },
            }),
*/

            hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
            cr.c(TextC.N, {
              key: -10,
              abtType: 'rmkCmnz',
              boxStlz: a(`dw/f fd/rsc mb/1`),
              textz: {
                pfx: '※：必須'
              }
            })
            : null,

            cr.c(SrlC.V, {
              key: -20,
              abtType: 'cttCmnz',
              oClds: [

                cr.c(_cv_41___Ci.D, {
                  key: -10,
                  sPz: pz.sPz,
                })

              ],
            }),

            cr.c(_cv_41___Ci.B, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',                
              }
            })

          ]
        })

      ]
    })
  );
};

